import SharedCompanyStats from '@/features/companyDashboard/common/SharedCompanyStats';

interface PartnerCompanyStatsProps {
  isCompact?: boolean;
}

const PartnerCompanyStats = ({ isCompact }: PartnerCompanyStatsProps) => (
  <SharedCompanyStats isCompact={isCompact} />
);

export default PartnerCompanyStats;
